import { CONVERSATION_TYPES } from '@/store/constants'

const HINT_TEXT = Object.freeze({
  QUICK_REPLIES: 'Answer with Quick Replies cannot have more content.',
  BLOCK: 'To modify, open the block editor and change its answer end to "continue".'
})

const CUSTOMER_TEXT = {
  WAIT_FOR_INPUT: 'Customer replies with something . . .',
  WAIT_FOR_VALIDATED_INPUT: contextKey => `User input is saved as <code>${'${context.' + contextKey + '}'}</code>`
}

const CHART_TEXT = Object.freeze({
  REQUEST_HINT: `A <b>request</b> starts with a customer enquiry ("Hello, I'm looking for my PIN.")
    and ends when the enquiry is completely solved (even unsuccessfully).`,
  CONTACT_HINT: `A <b>contact</b>  represents a customer that made at least one interaction via a
    messaging channel (Facebook Messenger, Amio Chat, ...) with your business. A contact can have
    multiple requests.`,
  REQUEST_ANSWERED_BY_BOT_HINT: `Shows how many <b>requests</b> were automatically answered by the bot.
    <br /><br />
    It is not correlated with customer satisfaction.
    <br /><br />
    Check the <b>Customer feedback</b> chart to get an
    overview of customer satisfaction with the bot's answer.`,
  CONTACT_ANSWERED_BY_BOT_HINT: `Shows the percentage of contacts with at least one Fully Automated
    request.`,
  AUTOMATION_RATE_HINT_REQUEST: `Chart sums up <b>outcomes of every request</b> per category.
    <br /><br />
    For example, if a contact has requests with the outcomes "Fully automated", "Fully automated"
    and "Wrong answer", it will add 2 to "Fully automated" and 1 to "Wrong answer".`,
  AUTOMATION_RATE_HINT_CONTACT: `Chart shows how many <b>contacts</b> have encountered each
    <b>request outcome</b>.
    <br /><br />
    For example, if a contact has requests with the outcomes "Fully automated", "Fully automated"
    and "Wrong answer", it will add 1 to "Fully automated" and 1 to "Wrong answer".`,
  REQUEST_ASSISTANCE_TYPE_HINT: `The chart shows the resolution of every <b>request</b>.
    <br /><br />`,
  CONTACT_ASSISTANCE_TYPE_HINT: `Chart shows how many contacts have received each type of
    assistance. One contact might be represented in multiple categories if the contact has made
    multiple requests with different type of assistance.
    <br /><br />`,
  PUBLISHED_ANSWERS_HINT: `Shows how many answers are <b>published</b> (the left number) in contrast
    to the total number of answers (the right number).`
})

const DELETE_TEXT = Object.freeze({
  [CONVERSATION_TYPES.ANSWERS]: {
    title: 'Delete Answer?',
    getDescription: (answerName) => `This will delete "${answerName}". It cannot be undone.`,
    confirm: 'Delete Answer'
  },
  [CONVERSATION_TYPES.EVENTS]: {
    title: 'Delete Event?',
    getDescription: (eventName) => `This will delete "${eventName}". It cannot be undone.`,
    confirm: 'Delete Event'
  },
  [CONVERSATION_TYPES.TEMPLATES]: {
    title: 'Delete Block?',
    getDescription: (blockName) => `This will delete "${blockName}". It cannot be undone.`,
    confirm: 'Delete Block'
  }
})

const CREATE_BUTTON_LABELS = {
  DEFAULT: 'Create',
  ERROR: 'Create failed!',
  SUCCESS: 'Created!'
}

const SAVE_BUTTON_LABELS = {
  DEFAULT: 'Save changes',
  ERROR: 'Saving failed!',
  SUCCESS: 'Saved!'
}

const DEFAULT_EXAMPLE = '(no example available)'

const DEFAULT_EXTRACT_PROMPT = 'Extract all important information from the following text and format it as a markdown bullet list. Do not comment on the text, just extract the information.'

export { HINT_TEXT, CUSTOMER_TEXT, CHART_TEXT, DELETE_TEXT, DEFAULT_EXAMPLE, SAVE_BUTTON_LABELS, CREATE_BUTTON_LABELS, DEFAULT_EXTRACT_PROMPT }
